export default __webpack_public_path__ + "static/media/Girdle of the Shivering Stars.12b23627.jpg";